import { IFrameStore } from '@rift/service/validation/database/syncrecording/IFrameStore';
import { IObjectStore } from '@shared/service/Indexeddb/IObjectStore';

export interface IDatabasePolygonFramesStore extends IFrameStore {
}

export class DatabasePolygonFramesStore implements IObjectStore {
    public static readonly keyPath: string = 'id';
    public static readonly recordingIdBlockIndex: string = 'RecordingIdBlockIndex';
    public static readonly recordingIdFrameNumberIndex: string = 'RecordingIdFrameNumberIndex';
    public static readonly recordingIdIndex: string = 'RecordingIdIndex';
    public static readonly storeDisplayName: string = 'Counts';
    public static readonly storeName: string = 'polygon';

    public get storeName(): string {
        return DatabasePolygonFramesStore.storeName
    };

    public static toInterface(): IDatabasePolygonFramesStore {
        return {
            storeName: this.storeName,
            keyPath: this.keyPath,
            recordingIdFrameNumberIndex: this.recordingIdFrameNumberIndex,
            recordingIdIndex: this.recordingIdIndex,
            recordingIdBlockIndex: this.recordingIdBlockIndex,
        } as IDatabasePolygonFramesStore;
    }

    public createStores(db: IDBDatabase): void {
        const store: IDBObjectStore = db.createObjectStore(DatabasePolygonFramesStore.storeName, { keyPath: DatabasePolygonFramesStore.keyPath, autoIncrement: true });
        store.createIndex(DatabasePolygonFramesStore.recordingIdFrameNumberIndex, ['recordingId', 'frameNumber'], { unique: true });
        store.createIndex(DatabasePolygonFramesStore.recordingIdBlockIndex, ['recordingId', 'block']);
        store.createIndex(DatabasePolygonFramesStore.recordingIdIndex, 'recordingId');
    }
}
